import { useContext, useMemo } from 'react';
import { EditorContext, EditorQueryContext, RicosContext } from 'ricos-context';
import type { IToolbarItemConfigTiptap } from 'ricos-types';

import { RicosToolbar } from '../../RicosToolbar';
import { ToolbarItemCreator } from '../../ToolbarItemCreator';

export const useCreateRicosToolbar = (itemConfig: IToolbarItemConfigTiptap[]) => {
  const { content } = useContext(RicosContext);
  const editorQuery = useContext(EditorQueryContext);
  const {
    adapter: { tiptapEditor },
  } = useContext(EditorContext);

  const toolbar = useMemo(() => {
    return RicosToolbar.create({
      toolbarItemCreators: itemConfig.map(config => ToolbarItemCreator.create(config)),
      content,
      tiptapEditor,
      editorQuery,
    });
  }, [itemConfig, content, tiptapEditor]);

  if (toolbar.shouldCreateToolbarItems()) {
    toolbar.createToolbarItems();
  }

  toolbar.update();

  return toolbar;
};
